import React, { Component } from 'react';
import ViewChats from './BabyItems/ViewChats';
import ViewMessage from './BabyItems/ViewMessage';
import { socket } from '../../utils/Connections';
import { checkCookie } from '../../utils/Cookies';
import ChatStore from '../../stores/ChatStore';
const transition = "all 0.3s ease-in-out",
    webtransition = {
        WebkitTransition: transition,
        MozTransition: transition,
        msTransition: transition,
        OTransition: transition,
        transition
    }

export default class Chat extends Component {
    state = {
        open: false,
        readingMessage: false,
        userId: '',
        userName: '',
        newMessageIn:false
    }
    componentDidMount() {
        const dashboardUnique={
            token:checkCookie("accessToken"),
            company:checkCookie("company").toLocaleLowerCase()
        }
        socket.emit("onlineDashboard",dashboardUnique)  
        socket.on("connect",()=>{
          socket.emit("onlineDashboard",dashboardUnique)   
        })
        socket.on("newMessage",()=>{
            this.setState({newMessageIn:true})
        })
        ChatStore.on("change",()=>{
            const data=ChatStore.getChatObject()
            this.setState({
                open: true,
                readingMessage: true,
                userId: data.userId,
                userName: data.userName
            })
        });
    }
    componentWillUnmount() {
    }
    render() {
        const { open, readingMessage, userName, userId, newMessageIn } = this.state
        return (
            <div style={{ position: 'fixed', bottom: 20, right: 20 }}>
                <div style={{
                    ...webtransition,
                    height: open ? 400 : 0,
                    width: open ? 250 : 0,
                    overflow: 'hidden',
                    backgroundColor: 'white',
                    marginBottom: 5,
                    borderRadius: 5,
                    padding: 0
                }} className={open ? `homecard` : ''}>
                    <div className="header" style={{
                        width: '100%',
                        backgroundColor: '#375139',
                        height: 35,
                        borderTopLeftRadius: 5,
                        borderTopRightRadius: 5,
                        display: 'flex',
                        alignItems: 'center',
                        paddingLeft: 10,
                        color: 'white'
                    }}>
                        <i onClick={() => this.setState({ readingMessage: false })} style={{
                            ...webtransition,
                            color: 'white',
                            overflow: 'hidden',
                            fontSize: 18,
                            width: readingMessage ? 17 : 0,
                            marginRight: readingMessage ? 10 : 0,
                            cursor: 'pointer'
                        }} className={`lnr lnr-arrow-left`}></i>
                        <div style={{textTransform:"capitalize"}}>{readingMessage ? userName : "Chats"}</div>
                    </div>
                    <div className="message-container" style={{ width: "100%", height: "100%", overflow: 'auto' }}>
                        {
                            readingMessage ?
                                <ViewMessage userId={userId} /> :
                                <ViewChats openChat={(name, id) => this.setState({
                                    readingMessage: true,
                                    userName: name,
                                    userId: id
                                })} />
                        }
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div onClick={() => this.setState({ open: !open, newMessageIn: false })} className="toggler"
                        style={{
                            backgroundColor: '#375139',
                            display: 'flex',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            alignItems: 'center',
                            width: 55,
                            height: 55,
                            borderRadius: "100%",
                            position: "relative"
                        }}>
                        {!open && newMessageIn && <div style={{
                            backgroundColor: "red",
                            width: 15,
                            height: 15,
                            borderRadius: "100%",
                            position: "absolute",
                            top: 0,
                            right: 0
                        }} />}
                        <i style={{ ...webtransition, color: 'white', fontSize: 18 }}
                            className={`lnr lnr-${open ? "cross" : "bubble"}`}></i>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/HomePageBabies/Chat.js